/**
 * Handles auto-correction of time value and validation to only allow valid chars.
 */
const createAutoCorrectionTimePipe = (timeFormat = 'HH:MM A') => {
  return conformedValue => {
    const indexOfPipedChars = []
    const timeFormatArray = timeFormat.split(/[^HMSA]+/)
    const maxValue = { HH: 12, MM: 59, SS: 59 }
    const minValue = { HH: 1, MM: 0, SS: 0 }
    const conformedValueArr = conformedValue.toUpperCase().split('')

    // check first digit (for hours and minutes)
    timeFormatArray.forEach(format => {
      if (format !== 'A') {
        const position = timeFormat.indexOf(format)
        const maxFirstDigit = parseInt(
          maxValue[format].toString().substr(0, 1),
          10
        )
        if (parseInt(conformedValueArr[position], 10) > maxFirstDigit) {
          conformedValueArr[position + 1] = conformedValueArr[position]
          conformedValueArr[position] = '0'
          indexOfPipedChars.push(position)
        }
      }
    })

    // check for invalid time
    const isInvalid = timeFormatArray.some(format => {
      if (format !== 'A') {
        const position = timeFormat.indexOf(format)
        const length = format.length
        const textValue = conformedValue
          .substr(position, length)
          .replace(/\D/g, '')
        const value = parseInt(textValue, 10)

        return (
          value > maxValue[format] ||
          (textValue.length === length && value < minValue[format])
        )
      }

      return false
    })

    if (isInvalid) return false

    return {
      value: conformedValueArr.join(''),
      indexOfPipedChars,
    }
  }
}

export default createAutoCorrectionTimePipe
